import { axios } from "../../cores/axiosWrapper";

import queryString from "../../cores/queryString";
import compareVersions, { VERSION_CM_15864_ITEM_SETS_V3, VERSION_CM_7510_SAFARI_ENCODING } from "@cores/version";

const MetadataFieldItemSetsApi = {
    createAsync: async function (version, stageId, apiEndpoint, data) {
        return axios.post(`${apiEndpoint}/${version}/item-sets`, data, {
            headers: {
                stageId,
            },
        });
    },

    getListAsync: async function (version, stageId, apiEndpoint, projectId, query) {
        const queries = {
            limit: query.limit || 1000,
        };

        if (query.name) queries.name = query.name;

        if (query.nextToken) queries.nextToken = query.nextToken;

        const headers = { stageId };
        if (projectId) headers.projectId = projectId;

        return axios.get(`${apiEndpoint}/${version}/item-sets?${queryString.stringify(queries)}`, {
            headers,
        });
    },

    updateAsync: async function (version, stageId, apiEndpoint, id, data) {
        return axios.put(`${apiEndpoint}/${version}/item-sets/${id}`, data, {
            headers: {
                stageId,
            },
        });
    },
    deleteAsync: async function (version, stageId, apiEndpoint, id) {
        return axios.delete(`${apiEndpoint}/${version}/item-sets/${id}`, {
            headers: {
                stageId,
            },
        });
    },
};

export default MetadataFieldItemSetsApi;
